import { KeyboardEvent, RefObject } from 'react';

import { KeyEventEnum } from 'components/auth/auth.enums';

type Callback<EventElement> = (e?: KeyboardEvent<EventElement>) => void;

type OnlyFunction<EventElement> = {
  [key in keyof EventElement]: EventElement[key] extends Function ? key : never;
};

type AllowedNames<Base> = OnlyFunction<Base>[keyof Base];

export const handleKeyDown = <EventElement>(key: KeyEventEnum, callback: Callback<EventElement>) => {
  return (event: KeyboardEvent<EventElement>) => {
    if (event.key === key) {
      callback(event);
    }
  };
};

//trigger focus change to forwarded ref
export const triggerEventOnEnterKeyDown = <EventElement extends {}>(
  ref: RefObject<EventElement>,
  method: AllowedNames<EventElement>,
) => {
  return handleKeyDown(KeyEventEnum.Enter, () => {
    if (ref.current) {
      (ref.current[method] as unknown as () => void)();
    }
  });
};
